import { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import RequiredInput from '../../../common/form/elements/required-input';

const model = 'game_levels';

// Every input needs its own controlId. RequiredInput's default is generated once when the module
// loads, not once per input, so anything leaving it out shares one DOM id with every other such
// input on the page - and each label then points at the first of them, so clicking "Prize amount
// points" or "Game link" puts the cursor in the scans box.

class GameLevelFormColumn extends Component {
  render() {
    const { level } = this.props;

    return (
      <Col className="game-levels-box" md={3}>
        <Row>
          <Col md={12}>
            Game level {level}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              controlId={`game-level-${level}-minimum-number-of-scans`}
              label="Min. Number of Scans"
              messages={{ stepMismatch: 'Value must be a whole number' }}
              model={`.${model}.level-${level}.minimum-number-of-scans.value`}
              type="number"
              min={1}
              step={1}
              positive
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              controlId={`game-level-${level}-prize-amount`}
              label="Prize amount points"
              model={`.${model}.level-${level}.prize-amount.value`}
              type="number"
              min={0}
              step="any"
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              controlId={`game-level-${level}-cataboom-id`}
              label="Game link"
              model={`.${model}.level-${level}.cataboom-id.value`}
              type="text"
            />
          </Col>
        </Row>
      </Col>
    );
  }
}

export default GameLevelFormColumn;
